import { savePending, saveFulfilled, saveRejected } from './features/ui/uiSlice'
import { setAuthToken, setOmniauthToken } from './features/user/userSlice'

const responseHandler = (dispatch) => (response) => {
  {
    // console.log(
    //   'responseHandler() response:',
    //   response,
    //   'response.status:',
    //   response.status,
    //   'response.body:',
    //   response.body
    // )

    checkForCSRFToken(dispatch, response)

    // A refusal still comes back as `undefined` to the caller, but the error
    // shown is the server's reason when it sends one (`{errors: {attr:
    // [messages]}}`, from application/error.json.erb), not just the status.
    if (response.status >= 400) {
      const statusMessage = `${response.status} - ${response.statusText}`
      return response.json().then(
        (json) => {
          dispatch(saveRejected({ error: serverReason(json) || statusMessage }))
        },
        () => {
          dispatch(saveRejected({ error: statusMessage }))
        }
      )
    }

    return response.json().then(
      (json) => {
        // console.log('responseHandler() response.json:', json)
        if (json.status >= 400) {
          dispatch(saveRejected(json))
          return
        }
        dispatch(saveFulfilled())
        return json
      },
      (error) => {
        // console.log('responseHandler() response.error:', error)
        return
      }
    )
  }
}

// Every message in an `{errors: {attr: [messages]}}` body, as one line, or
// nothing if the body isn't that shape.
const serverReason = (json) => {
  const errors = json?.errors
  if (!errors || typeof errors !== 'object') {
    return ''
  }
  return Object.values(errors).flat().filter(Boolean).join(' ')
}

const errorHandler = (dispatch) => (error) => {
  checkForCSRFToken(dispatch, error.response)
  dispatch(saveRejected())
  // console.log(`${addr} An error occurred`, error)
}

export const get = function (addr, dispatch) {
  // console.log('client.get() addr:', addr, 'dispatch:', dispatch)
  dispatch(savePending())
  return fetch(addr).then(responseHandler(dispatch), errorHandler(dispatch))
}

export const post = function (addr, data, dispatch) {
  dispatch(savePending())
  return fetch(addr, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  }).then(responseHandler(dispatch), errorHandler(dispatch))
}

export const put = function (addr, data, dispatch) {
  // console.log('client.put() addr:', addr, 'data:', data, 'dispatch:', dispatch)
  dispatch(savePending())
  return fetch(addr, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  }).then(responseHandler(dispatch), errorHandler(dispatch))
}

export const destroy = function (addr, data, dispatch) {
  dispatch(savePending())
  return fetch(addr, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  }).then(responseHandler(dispatch), errorHandler(dispatch))
}

function checkForCSRFToken(dispatch, response) {
  // Check for a CSRF header
  const csrfToken = response?.headers?.get('X-CSRF-Token')
  if (csrfToken) {
    // console.log('csrfToken:', csrfToken)
    dispatch(setAuthToken(csrfToken))
  }
  // OmniAuth's own request-phase CSRF token -- see
  // ApplicationController#set_csrf_token. Kept fresh the same way, so it
  // never goes stale after a sign-out.
  const omniauthToken = response?.headers?.get('X-OmniAuth-CSRF-Token')
  if (omniauthToken) {
    dispatch(setOmniauthToken(omniauthToken))
  }
}
